import { render, staticRenderFns } from "./AiGoalPlanFormContainer.vue?vue&type=template&id=21a48662&"
import script from "./AiGoalPlanFormContainer.vue?vue&type=script&lang=js&"
export * from "./AiGoalPlanFormContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports